export const environment = {
  production: true,
  baseurl : 'https://api.peraldefood.com',
  // baseurl : 'http://127.0.0.1:8000',

  pk: '',
  apikey: "",
  cld: '',
  psh: "",
  pubk: ""
};
